export default __webpack_public_path__ + "static/media/bb4.1.cca16664.png";